<template>
  <v-card class="detail-card">
    <purcharse-order-line-item-update
      :productId="productId"
      :routeDescription="routeDescription"
      v-on:close="closeUpdateItemDialog"
      v-on:updated="updated"
    >
    </purcharse-order-line-item-update>
    <v-card-title>
      <h3>{{title}}</h3>
    </v-card-title>
    <v-card-text>
       <v-data-table
        :headers="computedHeadersTotals"
        :items="[1]"
        hide-actions
        class="elevation-1"
        item-key="id"
        :pagination.sync="pagination"
      >
        <template v-slot:items="">
        </template>
        <template slot="footer">
          <tr>
            <td v-if="showDetails"><strong >Totales</strong></td>
            <td class="text-xs-right" v-if="showDetails">{{ totals.whole  | currency('', 0) }}</td>
            <td class="text-xs-right" v-if="showDetails">{{ totals.three_quarter | currency('', 0) }}</td>
            <td class="text-xs-right" v-if="showDetails">{{ totals.half | currency('', 0) }}</td>
            <td class="text-xs-right" v-if="showDetails">{{ totals.quarter | currency('', 0) }}</td>
            <td class="text-xs-right" v-if="showDetails">{{totals.whole + (totals.three_quarter * 0.75 ) + (totals.half * 0.5) + (totals.quarter * 0.25) | currency('', 2)  }}</td>
            <td class="text-xs-right" v-if="showDetails">{{ totals.grams_weigth  | currency('', 2) }} ({{ totals.grams_weigth * 0.0022046  | currency('', 2) }})</td>
            <td class="text-xs-right" v-if="showDetails">{{totals.payed_price  | currency('$', 2)}}</td>
            <td class="text-xs-right" v-if="showDetails">{{totals.subtotal_d_list_price | currency('$', 2)}}</td>
            <td v-if="showDetails">&nbsp;</td>

            <td v-if="!showDetails"><strong >Totales</strong> </td>
            <td class="text-xs-right" v-if="!showDetails">{{totals.whole + (totals.three_quarter * 0.75 ) + (totals.half * 0.5) + (totals.quarter * 0.25) | currency('', 2)  }}</td>
            <td class="text-xs-right" v-if="!showDetails">{{totals.grams_weigth  | currency('', 2) }} ({{ totals.grams_weigth * 0.0022046  | currency('', 2) }})</td>
            <td class="text-xs-right" v-if="!showDetails">{{totals.payed_price | currency('$', 2)}}</td>
            <td class="text-xs-right" v-if="!showDetails">{{totals.subtotal_d_list_price | currency('$', 2)}}</td>
          </tr>
        </template>
      </v-data-table>

      <v-data-table
        :headers="computedHeaders"
        :items="onlyCatalystItems"
        hide-actions
        class="elevation-1"
        item-key="id"
        no-data-text="No hay información que mostrar"
        :pagination.sync="pagination"
      >
        <template v-slot:items="props">
            <td class="text-xs-left">
              <a v-if="!currentBag ||  currentBag.status !== 'CLOSE'" class="link-style" @click="showUpdate(props.item)">{{ props.item.serial_number }}</a>
              <span v-else>{{ props.item.serial_number }}</span>
            </td>
            <td v-if="showOperations" ><v-icon color="red" @click="deleteItem(props.item)">delete_forever</v-icon></td>
            <td class="text-xs-right" v-if="showDetails">{{ props.item.whole | currency('', 0) }}</td>
            <td class="text-xs-right" v-if="showDetails">{{ props.item.three_quarter | currency('', 0) }}</td>
            <td class="text-xs-right" v-if="showDetails">{{ props.item.half | currency('', 0) }}</td>
            <td class="text-xs-right" v-if="showDetails">{{ props.item.quarter | currency('', 0) }}</td>
            <td class="text-xs-right" >{{ props.item.weigth | currency('', 0) }}</td>
            <td class="text-xs-left" v-if="showRoute">
              <router-link :to="routeLink(props.item)">{{ props.item.route_description }}</router-link>
            </td>
            <td class="text-xs-right">{{ lineTotals(props.item).units }} ({{ lineTotals(props.item).pieces }})  </td>
            <td class="text-xs-right">{{ lineTotals(props.item).real_weigth | currency('',2) }} ({{lineTotals(props.item).real_weigh_lbl | currency('',2)}})</td>
            <td class="text-xs-right">{{ lineTotals(props.item).payed_price  | currency('$', 2) }}</td>
            <td class="text-xs-right">{{ props.item.subtotal_d_list_price | currency('$', 2) }}</td>
            
        </template>
        <template slot="footer">
          <tr>
            <td v-if="showDetails"><strong >Totales</strong></td>
            <td v-if="showDetails">&nbsp;</td>
            <td class="text-xs-right" v-if="showDetails">{{ totals.whole  | currency('', 0) }}</td>
            <td class="text-xs-right" v-if="showDetails">{{ totals.three_quarter | currency('', 0) }}</td>
            <td class="text-xs-right" v-if="showDetails">{{ totals.half | currency('', 0) }}</td>
            <td class="text-xs-right" v-if="showDetails">{{ totals.quarter | currency('', 0) }}</td>
            <td class="text-xs-right" v-if="showDetails">-</td> <!-- This must be blanck because it has no meaning sum each weigth of piece-->
            <td class="text-xs-right" v-if="showDetails">{{totals.whole + (totals.three_quarter * 0.75 ) + (totals.half * 0.5) + (totals.quarter * 0.25) | currency('', 2)  }}</td>
            <td class="text-xs-right" v-if="showDetails">{{ totals.grams_weigth  | currency('', 2) }} ({{ totals.grams_weigth * 0.0022046  | currency('', 2) }})</td>
            <td class="text-xs-right" v-if="showDetails">{{totals.payed_price  | currency('$', 2)}}</td>
            <td class="text-xs-right" v-if="showDetails">{{totals.subtotal_d_list_price | currency('$', 2)}}</td>
            <td v-if="showDetails">&nbsp;</td>

            <td v-if="!showDetails"><strong >Totales</strong> </td>
            <td v-if="!showDetails">&nbsp;</td>
            <td v-if="!showDetails">&nbsp;</td>
            
            <td class="text-xs-right" v-if="!showDetails">{{totals.whole + (totals.three_quarter * 0.75 ) + (totals.half * 0.5) + (totals.quarter * 0.25) | currency('', 2)  }}</td>
            <td class="text-xs-right" v-if="!showDetails">{{totals.grams_weigth  | currency('', 2) }} ({{ totals.grams_weigth * 0.0022046  | currency('', 2) }})</td>
            <td class="text-xs-right" v-if="!showDetails">{{totals.payed_price | currency('$', 2)}}</td>
            <td class="text-xs-right" v-if="!showDetails">{{totals.subtotal_d_list_price | currency('$', 2)}}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
<script>

import _ from 'lodash';

import { PUOND_CONVERT } from '../../utils/constants';


export default {
  props: {
    items: Array,
    title: String,
    showRoute: {
      type: Boolean,
      default: false,
    },
    showDetails: {
      type: Boolean,
      default: true,
    },
    showOperations: {
      type: Boolean,
      default: true,
    },
    currentBag: {
      type: Object,
    },
  },
  data() {
    return {
      detailHeaders: [
        { text: 'Serie', value: 'serial_number', width: '1%' },
         // The isDetail attr is only used to filter headers on the computed value below
        { text: '', width: '1%', sortable: false, isOperation: true },
        { text: '1', value: 'whole', width: '1%', isDetail: true },
        { text: '3/4', value: 'three_quarter', width: '1%', isDetail: true },
        { text: '1/2', value: 'half', width: '1%', isDetail: true },
        { text: '1/4', value: 'quarter', width: '1%', isDetail: true },
        { text: 'Peso Pza', width: '1%', sortable: false },
        { text: 'Ruta', value: 'route_description'},
        { text: 'Piezas', width: '1%', sortable: false },
        { text: 'Peso Linea gr(lb)', width: '1%', sortable: false },
        { text: 'Total $', value: 'payed_price', width: '1%' },
        { text: 'Lista D', value: 'subtotal_d_list_price', width: '1%' },
      ],
      pagination: {
        sortBy: 'id',
        descending: false,
        rowsPerPage: -1,
      },
      productId: 0,
      routeDescription: '',
    };
  },
  methods: {
    lineTotals(lineItem) {
      const units = lineItem.whole + lineItem.three_quarter + lineItem.half + lineItem.quarter;
      const pieces = lineItem.whole + (lineItem.three_quarter * 0.75 ) +
        (lineItem.half * 0.5) + (lineItem.quarter * 0.25);
      const realWeigth = pieces * lineItem.weigth;
      const payedPrice = lineItem.payed_price * pieces;
      return {
        units,
        pieces,
        real_weigth: realWeigth,
        real_weigh_lbl: realWeigth *  PUOND_CONVERT,
        payed_price: payedPrice,
      };
    },
    getTotalItems(detail) {
      const items = (parseFloat(detail.whole) * 1) +
        (parseFloat(detail.three_quarter) * 0.75) +
        (parseFloat(detail.half) * 0.5) +
        (parseFloat(detail.quarter) * 0.25);
      const pieces = (detail.whole) +
        (detail.three_quarter) +
        (detail.half) +
        (detail.quarter);
      return items;
    },
    deleteItem(event) {
      this.$emit('deleteItem', event);
    },
    routeLink(row) {
      return `/bag/${this.currentBag.id}/route/${row.route_id}`;
    },
    showUpdate(row) {
      this.productId = row.id;
      this.routeDescription = row.route_description;
    },
    closeUpdateItemDialog() {
      this.productId = 0;
      this.routeDescription = '';
    },
    updated() {
      this.productId = 0;
      this.$emit('updated', 'Pieza actualizada');
    },
  },
  computed: {
    totals() {
      const initialValues = {
          whole: 0,
          three_quarter: 0,
          half: 0,
          quarter: 0,
          total_pieces: 0,
          payed_price: 0.00,
          grams_weigth: 0.00,
          subtotal_d_list_price: 0.00,
          real_pieces: 0.00,
      };
      if (!this.items || this.items.length === 0) {
        return initialValues;
      } else {
        const results = Object.assign({}, initialValues);
        for (const line of this.items) {
          results.whole += parseInt(line.whole, 10);
          results.three_quarter += parseInt(line.three_quarter, 10);
          results.half += parseInt(line.half, 10);
          results.quarter += parseInt(line.quarter, 10);
          results.real_pieces = this.getTotalItems(line);
          results.payed_price += parseFloat(line.payed_price) * results.real_pieces;
          results.grams_weigth += parseFloat(line.weigth) * this.getTotalItems(line);
          results.subtotal_d_list_price += parseFloat(line.subtotal_d_list_price);
        }
        return results;
      }
    },
    computedHeadersTotals(){
      let headers = this.computedHeaders
      let newHeaders = []
      headers.forEach(element => {
        console.log(element.text);
        const newElement = Object.assign({}, element)
        if(element.text === 'Serie'){
          newElement.text = ""
        }
        if(this.showDetails){
          if(element.text !== 'Ruta' && element.text !== '1'){
            newHeaders.push(newElement)
          }
        }else {
          if(element.text !== "Peso Pza" &&  
              element.text !== 'Ruta' &&
              element.text !== '1'){
            newHeaders.push(newElement)
          }
        }
        
        // newHeaders.push(newElement)

      });
      return newHeaders
    },
    computedHeaders() {
      let results = this.detailHeaders;
      if (!this.showRoute) {
        results = results.filter((e) => {
          return e.text !== 'Ruta';
        });
      }
      if (!this.showDetails) {
        results = results.filter((e) => {
          return !e.isDetail;
        });
      }
      if (!this.showOperations) {
        results = results.filter((e) => {
          return !e.isOperation;
        });
      }
      return results;
    },
    onlyCatalystItems() {
      return this.items.filter((e) => e.type === 'CATALYST');
    },
  },
};
</script>

<style>
.col-header {
  background-color: rgba(0, 0, 0, .05); 
  padding-bottom: 10px; 
  padding-top: 10px
}

.link-style {
  text-decoration: underline blue;
}

</style>